//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BtnToggle from '../../btnToggle/index.vue';
import x24icarrowleft from '../../../../../iconsPublicSite/icons/x24icarrowleft/x24icarrowleft';
import x24icarrowright from '../../../../../iconsPublicSite/icons/x24icarrowright/x24icarrowright';

import calendarYear from '../../../../../components/datePicker/calendar/calendarYear';

export default {
  components: {
    BtnToggle,
    x24icarrowleft,
    x24icarrowright,
  },
  extends: calendarYear,
};
